import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { map, catchError } from 'rxjs/operators';

import { Observable, throwError } from 'rxjs';
import { StreamHistory, StreamHistoryReport } from '../_models';
import { ArrayResponse, BaseResponse, ListResponse } from '../_common';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class StreamHistoryService {

  constructor(private http: HttpClient) { }

  getAll(filter: any): Observable<any>  { //listing
    return this.http.post(`${environment.apiUrl}/stream/history/list`, filter)
    .pipe(
      map((data: any) => {
        if(data.status == 1 && data.data && data.data.list){
            return new ListResponse().deserialize(data, StreamHistory);
        }else{
           return {status:null, msg: data.msg};
        }
      }),
      catchError(error => throwError(error.message || error))
    );
  }

  export(filter: any): Observable<any> { //export
    return this.http.post(`${environment.apiUrl}/stream/history/export`, filter);
  }

  getDailyReport(filter: any): Observable<any>  { //listing
    return this.http.post(`${environment.apiUrl}/stream/history/graph`, filter)
    .pipe(
      map((data: any) => {
        if(data.status == 1 && data.data){
            return new ArrayResponse().deserialize(data, StreamHistoryReport);
        }else{
           return {status:null, msg: data.msg};
        }
      }),
      catchError(error => throwError(error.message || error))
    );
  }

  reportExport(filter: any): Observable<any> { //export
    return this.http.post(`${environment.apiUrl}/stream/history/graph-export`, filter);
  }

}
